import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueI18n from "./locales/index";
import VConsole from "vconsole";
import "normalize.css";
import "element-plus/dist/index.css";
import { Popup, Dialog } from "vant";
import "core-js/stable";
import "regenerator-runtime/runtime";
import SlsTracker from "@aliyun-sls/web-track-browser";

if (
  ["development", "beta", "local"].includes(process.env.NODE_ENV!) ||
  /vConsole/.test(location.href)
) {
  new VConsole();
}

const tracker = new SlsTracker({
  host: "cn-shenzhen.log.aliyuncs.com", // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
  project: "ht-web-live-cn", // Project名称。
  logstore: "ht-web-live-cn", // Logstore名称。
  time: 10, // 发送日志的时间间隔，默认是10秒。
  count: 2, // 发送日志的数量大小，默认是10条。
  topic: "web充值H5", // 自定义日志主题
});

const app = createApp(App);
app.use(VueI18n);
app.use(store);
app.use(router);
app.use(Popup);
app.use(Dialog);
app.mount("#app");
app.config.globalProperties.$log = tracker;

const jsBrigeHook = ["onReady", "onShow", "onHide", "onUnload"];
jsBrigeHook.forEach((hook) => {
  // eslint-disable-next-line
  // @ts-ignore
  // eslint-disable-next-line
  window[hook] = () => {};
});
